module.exports = __webpack_public_path__ + "img/layers-3.6d9e1ae6.svg";